// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-56914b41],select[data-v-56914b41],textarea[data-v-56914b41]{font-size:16px}}.ps-list--link[data-v-56914b41]{font-size:17px}.ps-list--social li a.linkedin i[data-v-56914b41]{color:#0077b5}.youtube[data-v-56914b41]{color:red}.footer[data-v-56914b41]{color:#fb9013;font-size:20px}.foter[data-v-56914b41]{color:#fb9013;font-size:19px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
